/**
 * @deprecated Use `routes` from '@/lib/routing' instead.
 * This file is kept for backward compatibility.
 * 
 * Migration:
 *   // Old:
 *   import { RoutePath } from '@/lib/routes';
 *   RoutePath.Device('123');
 *   
 *   // New:
 *   import { routes } from '@/lib/routing';
 *   routes.device({ deviceId: '123' });
 */

import { routes } from './routing';

const Customer = (customerId: string) => `/customers/${customerId}`;
const Site = (siteId: string) => `/sites/${siteId}`;
const CustomerSite = (customerId: string, siteId: string) =>
  routes.customerSite({ customerId, siteId });
const Devices = () => routes.devices();
const Device = (deviceId: string) => routes.device({ deviceId });
const DeviceEdit = (deviceId: string) => routes.deviceEdit({ deviceId });
const DeviceCamera = (deviceId: string, cameraId: string) =>
  routes.deviceCamera({ deviceId, cameraId });
const Dashboard = () => routes.dashboard();
const Reporting = () => routes.reporting();

/** @deprecated Use `routes` from '@/lib/routing' instead */
export const RoutePath = {
  Customer,
  Site,
  CustomerSite,
  Devices,
  Device,
  DeviceEdit,
  DeviceCamera,
  Dashboard,
  Reporting,
};

// Re-export new routing utilities for convenience
export { routes } from './routing';
